import type { InferRequestType, InferResponseType } from 'hono/client';
import { type ApiClient, useFetch, useMutation } from '../api';

type GetDevice = ApiClient['v5']['devices'][':deviceId']['$get'];
export type DeviceResponse = InferResponseType<GetDevice, 200>;

type PatchDevice = ApiClient['v5']['devices'][':deviceId']['$patch'];
export type PatchDeviceRequest = InferRequestType<PatchDevice>['json'];
type PatchResponse = InferResponseType<PatchDevice, 200>;

export function useDevice(deviceId: number) {
  return useFetch<DeviceResponse>(`devices/${deviceId}`, (client) =>
    client.v5.devices[':deviceId'].$get({
      param: { deviceId: deviceId.toString() },
    })
  );
}

export function useUpdateDevice(deviceId: number) {
  return useMutation<PatchResponse, PatchDeviceRequest>(`devices/${deviceId}`, (client, updates) =>
    client.v5.devices[':deviceId'].$patch({
      param: { deviceId: deviceId.toString() },
      json: updates,
    })
  );
}
